import { Box, Drawer, useMediaQuery } from "@mui/material";
import AppBarLogo from "@/components/base/app/AppBarLogo";
import { useTheme } from "@emotion/react";
import { useImpersonation } from "@/layouts/components/layoutContext";

export default function DrawerWrapper({
    children,
    mobileOpen,
    drawerWidth,
    handleDrawerToggle,
}) {
    const theme = useTheme();
    const mobileViewMatches = useMediaQuery(theme.breakpoints.down("sm"));

    const [impersonated, _] = useImpersonation();

    return (
        <Box
            sx={{
                width: { sm: drawerWidth },
                flexShrink: { sm: 0 },
            }}
        >
            {mobileViewMatches && (
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        "& .MuiPaper-root": {
                            top: impersonated ? "30px" : "0",
                        },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                >
                    <AppBarLogo />
                    {children}
                </Drawer>
            )}

            {!mobileViewMatches && (
                <Drawer
                    variant="permanent"
                    sx={{
                        "& .MuiPaper-root": {
                            top: impersonated ? "30px" : "0",
                        },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth,
                        },
                    }}
                    open
                >
                    <AppBarLogo />
                    {children}
                </Drawer>
            )}
        </Box>
    );
}
